import { WorkflowQuestionConfig } from '../workflowQuestionConfig';
import { WorkflowResponseState } from '../workflowResponseState';

export interface SignatureQuestionConfig extends WorkflowQuestionConfig {}

export interface SignatureResponseState extends WorkflowResponseState {
  mediaId: string;
}
